import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { baseAPI } from '../../services/baseAPI';

function TambahDate() {
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [newData, setNewData] = useState({
    date_name: "",
    start_date: "",
    end_date: "",
    updated_by: user.npp,
  });
  const [isLoading, setIsLoading] = useState(false);


  // CONTROLLER
  const storeNewDate = () => {
    Swal.fire({
      title: 'Do you want to save new data?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Save',
      denyButtonText: `Don't save`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('new_data', JSON.stringify(newData));

        baseAPI
          .post(`/v1/dsetting`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "New date has been added.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Failed add new date.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
          })
      } else if (result.isDenied) {
        Swal.fire('New date is not added', '', 'info')
      }
    });
  }
  

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Setting</Link> /{' '}
              <Link to='/setting/settingdate/tambahdate' style={{ color: '#333' }}>Tambah Date</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Tambah Date</b></p>
              </div>

              {/* Nama biaya */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama Tanggal
                </label>
                <input
                  className="form-control"
                  onChange={e => setNewData({...newData, date_name: e.target.value})}
                />
              </div>

              {/* Start Date */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Mulai
                </label>
                <input
                  type='number'
                  className="form-control"
                  onChange={e => setNewData({...newData, start_date: e.target.value})}
                />
              </div>

              {/* Start Date */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Selesai
                </label>
                <input
                  type='number'
                  className="form-control"
                  onChange={e => setNewData({...newData, end_date: e.target.value})}
                />
              </div>

              <div className='col-md-12'>
                <button
                  disabled={newData.nama_biaya !== "" && newData.biaya !== "" && newData.deskripsi !== "" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => storeNewDate()}
                >
                  Save
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default TambahDate;